import React from 'react';
const HERO_BG = 'https://drwzpk38qkpfb.cloudfront.net/www.apc360zone.com/preview/uploaded/images/Redesigne%202024/About_bg.jpeg?opt=w3';
const LOGO_IMG = 'https://drwzpk38qkpfb.cloudfront.net/core/getthumb?file=uploaded%2Fimages%2FRedesigne%202024%2FMTDLarge.png400x400.png&site=1856&w=400&h=226&user=1516&opt=w3';
export function HeroSection() {
  return <section className="relative py-24 md:py-36 flex items-center border-b border-brand-gray-800 overflow-hidden" data-id="element-168">
      <img src={HERO_BG} alt="About Medina Tactical Dynamics" className="block absolute inset-0 w-full h-full object-cover" data-id="element-169" />
      <div className="absolute inset-0 bg-gradient-to-b from-brand-black/50 via-brand-black/40 to-brand-black z-[1]" data-id="element-170" />

      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10 w-full text-center" data-id="element-171">
        <img src={LOGO_IMG} alt="Medina Tactical Dynamics" className="block mx-auto mb-12 w-[300px] md:w-[400px] h-auto" data-id="element-172" />
      </div>
    </section>;
}